export default __webpack_public_path__ + "static/media/Linero4Open.a13a62d3.png";